import React, { useState, useEffect } from 'react';
import classes from './BankReconNew.module.css';
// import RegLogo from '../../Images/RegistrationLogo.svg'
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
// import Folder from '../../Images/folder-2.svg';
import axios from 'axios';
// import AsyncStorage from '@react-native-async-storage/async-storage';
// import ArrowLogo from '../../Images/arrow-left.svg';
// import LoanImage from '../../Images/loan bg.svg';
// import MainDashoard from '../Main Dashboard/MainDashoard';
// import Ready from '../../Images/nothing.svg'
// import Ready1 from '../../Images/review.svg';
// import favicon from '../../Images/faviconn.png'
import { Link, useNavigate, useParams } from 'react-router-dom'
// import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

import Select from 'react-select';
// import PaymentDash from '../Payment Dashboard/PaymentDash';
// import LatestDash from '../LatestDashboard/LatestDash';
// import portal from "../../assets/nw/portal.svg";
// import notification from "../../assets/nw/notification.svg";
// import user from "../../assets/nw/manageUser.svg";
// import modules from "../../assets/nw/modules.svg";
// import currency from "../../assets/nw/currency.svg";
// import down from "../../assets/nw/dropdown.svg";
// import plus from "../../assets/nw/plus.svg";
// import chart from "../../assets/nw/chart.svg"
// import vector from "../../assets/nw/vector.svg";
// import linear from "../../assets/nw/linear.svg";
// import s from "../../assets/nw/delete.svg";
// import downs from "../../assets/nw/down1.svg"
import { Tabs, Tab } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { IoChatbubblesSharp } from "react-icons/io5";
import { FaUpload } from "react-icons/fa";
import { FaDownload } from "react-icons/fa";
import { IoMdCheckmark } from "react-icons/io";
import { ImCancelCircle } from "react-icons/im";
import { FaRegSave } from "react-icons/fa";
import { GrPowerCycle } from "react-icons/gr";
import { FaPrint } from "react-icons/fa";
import MobileMenu from '../../Components/Mobile/MobileNav';
import { BASE_URL } from '../../Components/Styles/API/API';
import crop from "../../Assets/repoort.png";




export default function BankReconciliationNew() {
  const [currentPage, setCurrentPage] = useState(1);
  const [show, setShow] = useState(false);
  const [unmatch, setUnmatch] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [currentPages, setCurrentPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerms, setSearchTerms] = useState("");
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [bearer, setBearer] = useState('');
  const navigate = useNavigate();
  const [user, setUser] = useState('');
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [selectOptions1, setSelectOptions1] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [periodd, setPeriodd] = useState([]);
  const [selectedPeriodd, setSelectedPeriodd] = useState(null);
  const [selectedBank, setSelectedBank] = useState('');
  const [selectedBank2, setSelectedBank2] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedDate2, setSelectedDate2] = useState('');
  const [tableData, setTableData] = useState([]);
  const [tableDatas, setTableDatas] = useState([]);
  const [newData, setNewData] = useState([]);
  const [currentPageDatas, setCurrentPageDatas] = useState([]);
  const [currentPageData, setCurrentPageData] = useState([]);
  const [newDatas, setNewDatas] = useState([]);
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [userType, setUserType] = useState('');
  const [userTypes, setUserTypes] = useState('');
  const [admin, setAdmin] = useState('');
  const [openNav, setOpenNav] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectAlls, setSelectAlls] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemss, setSelectedItemss] = useState([]);
  const [pendingUnmatchedIds, setPendingUnmatchedIds] = useState([]);
  const [totalCashbookBalance, setTotalCashbookBalance] = useState(0);
  const [totalStatementBalance, setTotalStatementBalance] = useState(0);
  const [matchedAmount, setMatchedAmount] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const [fixedDate, setFixedDate] = useState('');  
  const [matchedDisplayed, setMatchedDisplay] = useState(false);

const toKobo = (val) => Math.round(Number(val) * 100);
const fromKobo = (val) => val / 100;

useEffect(() => {
  setDisabled(Math.abs(matchedAmount) > 0.004);
}, [matchedAmount]);


  const ITEMS_PER_PAGE = 100;

  const totalPages = Math.ceil(tableData.length / ITEMS_PER_PAGE);
  const totalPages1 = Math.ceil(tableDatas.length / ITEMS_PER_PAGE);

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value2 = await localStorage.getItem('admin');
      const admins = await localStorage.getItem('admin');

      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (value2 !== null) {
        setAdmin(value2);
      }

      if (admins !== null) {
        setUserTypes(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();

  }, []);



  useEffect(() => {
  const savedId = localStorage.getItem("bankID");
  const savedDate = localStorage.getItem("cashbookDate");

  if (savedId !== null) {
    setSelectedBank2(savedId);
  }
  if (savedDate !== null) {
    setSelectedDate(savedDate);
  }

  const pendingIds = JSON.parse(localStorage.getItem("pendingUnmatchedIds") || "[]");
  if (Array.isArray(pendingIds) && pendingIds.length > 0) {
    setPendingUnmatchedIds(pendingIds);
  }
  }, []);

  useEffect(() => {
    const cleanupPendingIds = () => {
      localStorage.removeItem("pendingUnmatchedIds");
    };

    window.addEventListener("beforeunload", cleanupPendingIds);
    return () => {
      window.removeEventListener("beforeunload", cleanupPendingIds);
      if (pendingUnmatchedIds.length > 0) {
        localStorage.removeItem("pendingUnmatchedIds");
      }
    };
  }, [pendingUnmatchedIds]);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  



 const fetchTransaction = async () => {
  try {
    setLoad(true);


    const bearer = localStorage.getItem("userToken");
    // Decide which bank and date to use
    const bankToUse = selectedBank && selectedDate2 ? selectedBank : selectedBank2;
    const dateToUse = selectedBank && selectedDate2 ? selectedDate2 : selectedDate;

    if (!bankToUse || !dateToUse) {
      console.warn("Bank or date missing — skipping API call.");
      setLoad(false);
      return;
    }

    if (!bearer) {
      console.error("No authentication token found!");
      setLoad(false);
      return;
    }

    const response = await axios.get(`${BASE_URL}/get_unmatched_reconciliation`, {
      params: {
        account_id: bankToUse,
        date: dateToUse,
      },
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${bearer.trim()}`,
      },
    });

    console.log("API Response:", response.data);

    const statements = response.data?.data?.statements || [];
    const cashbooks = response.data?.data?.cashbooks || [];

    setTableDatas(statements);
    setTableData(cashbooks);
  } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }

    setTableDatas([]);
    setTableData([]);
  } finally {
    setLoad(false);
  }
};


  const fetchAllMatched = async () => {
    setLoad(true);
    try {
      const bankToUse = selectedBank && selectedDate2 ? selectedBank : selectedBank2;
      const dateToUse = selectedBank && selectedDate2 ? selectedDate2 : selectedDate;

      const response = await axios.get(
        `${BASE_URL}/get_matched_reconciliation`,
        {
          params: {
            account_id: bankToUse,
            date: dateToUse,
          },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`,
          },
        }
      );

      console.log(response);
      const results = response.data?.data?.statements;
      setTableDatas(results);
      const resultss = response.data?.data?.cashbooks;
      setTableData(resultss);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
      setTableDatas([]);
    } finally {
      setLoad(false);
    }
  };

  const fetchAllMatchedDate = async () => {
    setLoad(true);
    try {
      const bankToUse = selectedBank && selectedDate2 ? selectedBank : selectedBank2;
      const dateToUse = selectedBank && selectedDate2 ? selectedDate2 : selectedDate;

      const response = await axios.get(
        `${BASE_URL}/get_matched_reconciliation_with_date`,
        {
          params: {
            account_id: bankToUse,
            date: dateToUse
          },
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`,
          },
        }
      );

      console.log(response);
      const results = response.data?.data?.statements;
      setTableDatas(results);
      const resultss = response.data?.data?.cashbooks;
      setTableData(resultss);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
      setTableDatas([]);
    } finally {
      setLoad(false);
    }
  };



//  useEffect(() => {
//     if (bearer && selectedBank2) {
//       fetchTransaction(selectedBank2);
//     }
//   }, [bearer && selectedBank2]);


  // useEffect(() => {
  //   if (selectedMatch === 1) {
  //     fetchAllMatched();
  //     setMatchedDisplay(true);
  //   } else {
  //     fetchTransaction(selectedBank2);
  //     setMatchedDisplay(false);
  //   }
  // }, [selectedMatch]);

  // useEffect(() => {
  //   if (selectedMatch === 1) {
  //     fetchAllMatched();
  //     setMatchedDisplay(true);
  //   } else {
  //     fetchTransaction(selectedBank2);
  //     setMatchedDisplay(false);
  //   }
  // }, [selectedMatch]);

  useEffect(() => {
  const bankToUse = selectedBank && selectedDate2 ? selectedBank : selectedBank2;
  const dateToUse = selectedBank && selectedDate2 ? selectedDate2 : selectedDate;

  if (!bankToUse || !dateToUse) return; // prevent fetch if values are incomplete

  if (selectedMatch === 1) {
    fetchAllMatchedDate(); // your function already resolves which bank/date to use
    setMatchedDisplay(true);
  } else {
    fetchTransaction(); // also uses resolved bank/date inside
    fetchAllMatched(); // also uses resolved bank/date inside
    setMatchedDisplay(false);
  }
}, [selectedMatch, selectedBank, selectedBank2, selectedDate2, selectedDate]);


// useEffect(() => {
//   const bankToUse = selectedBank && selectedDate2 ? selectedBank : selectedBank2;
//   const dateToUse = selectedBank && selectedDate2 ? selectedDate2 : selectedDate;

//   if (!bankToUse || !dateToUse) return;

//   if (selectedMatch === 1) {
//     fetchAllMatched(); // 🟢 use this if you're not filtering by another specific date or route
//     setMatchedDisplay(true);
//   } else {
//     fetchTransaction(); // handles unmatched
//     setMatchedDisplay(false);
//   }
// }, [selectedMatch, selectedBank, selectedDate2, selectedBank2, selectedDate]);



  // useEffect(() => {
  //   if (selectedDate && selectedBank2) { 
  //     fetchAllMatchedDate(selectedDate && selectedBank2);
  //     setMatchedDisplay(true);
  //   } else {
  //     fetchTransaction(selectedBank2);
  //     setMatchedDisplay(false);
  //   }
  // }, [selectedDate && selectedBank2]);
 
  






  const handleBankChange = (selectedOption) => {
    setSelectedBank(selectedOption.value);
    setFixedDate(selectedOption.fixeddate);
    setMatchedDisplay(false);
    setSelectedPeriodd(null);
    setSelectedMatch(null);
  };

  const handlePeriodChangee = (selectedOption) => {
    setSelectedPeriodd(selectedOption.value);
    setMatchedDisplay(false);

  };
  const handleMatchChange = (selectedOption) => {
    setSelectedMatch(selectedOption.value);

  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    const daySuffix = getDaySuffix(day);

    return `${day} ${month}, ${year}`;
  }

  function getDaySuffix(day) {
    if (day > 3 && day < 21) return 'th'; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  const fetchDebit = async () => {
    setIsLoading(true);
    try {
      // const response = await axios.get(`${BASE_URL}/account/cash-and-bank`, { headers });
      const response = await axios.get(`${BASE_URL}/reconciliation/set-accounts`, { headers });
      const debitAcct = response.data?.data;

      const options1 = debitAcct.map((item) => ({
        label: item.gl_name,
        value: item.id,
        acNo: item.gl_code,
        fixeddate: item.setup?.smt_last_date,
      }));

      setTableData1(debitAcct);
      setSelectOptions1(options1);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData1([]);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchPerriod = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/get-province-matched-date`, { headers });
      const debitAcct = response.data?.data;

      const options12 = [
        { label: "Select Date", value: "" },
        ...debitAcct.map((item) => ({
          label: item,
          value: item,
        })),
      ];

      // setTableData1(debitAcct);
      setPeriodd(options12);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setPeriodd([]);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchDebit();
      fetchPerriod();
    }
  }, [bearer]);


  const filterTableData = () => {
    const normalizedSearchTerm = searchTerm.toLowerCase();
    const filteredData = tableData
      .filter(item => !pendingUnmatchedIds.includes(item.match_id))
      .filter(item =>
        item.description.toLowerCase().includes(normalizedSearchTerm) ||
        item.amount.toString().includes(normalizedSearchTerm)
      );

    // Paginate filtered data
    const paginatedData = filteredData.slice((currentPage - 1) * 100, currentPage * 100);
    setCurrentPageData(paginatedData);
  };

  // Function to filter and paginate data for tableDatas
  const filterTableDatas = () => {
    const normalizedSearchTerms = searchTerms.toLowerCase();
    const filteredDatas = tableDatas
      .filter(item => !pendingUnmatchedIds.includes(item.match_id))
      .filter(item =>
        item.description.toLowerCase().includes(normalizedSearchTerms) ||
        item.amount.toString().includes(normalizedSearchTerms)
      );

    // Paginate filtered data
    const paginatedDatas = filteredDatas.slice((currentPages - 1) * 100, currentPages * 100);
    setCurrentPageDatas(paginatedDatas);
  };

  useEffect(() => {
    filterTableData();
  }, [searchTerm, currentPage, tableData, pendingUnmatchedIds]);

  useEffect(() => {
    filterTableDatas();
  }, [searchTerms, currentPages, tableDatas, pendingUnmatchedIds]);

  // const currentPageDatas = filteredDatas.slice((currentPages - 1) * 100, currentPages * 100);
  // const currentPageData = filteredData.slice((currentPage - 1) * 100, currentPage * 100);

const handleSave = async () => {
  setLoading(true);

  try {
    // 1️⃣ Fetch saved matched data by bank
    // const savedResponse = await axios.get(
    //   `${BASE_URL}/account/get-saved-for-matched-by-bank`,
    //   {
    //     params: {
    //       bank_id: selectedBank2, // make sure this is the bank id
    //     },
    //     headers,
    //   }
    // );
    // console.log(savedResponse);
    // const cashbooks = savedResponse?.data?.data?.cashbooks || [];
    // const statements = savedResponse?.data?.data?.statements || [];

    // if (cashbooks.length === 0 || statements.length === 0) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "No Saved Data",
    //     text: "Please match items before saving.",
    //   });
    //   return;
    // }

    // 2️⃣ Extract required fields
    // const cashbookIds = cashbooks.map(item => item.cashbook_id);
    // const statementIds = statements.map(item => item.statement_id);
    // const cashbookAmounts = cashbooks.map(item => item.cashbooks_amount);
    // const statementAmounts = statements.map(item => item.statements_amount);

    // 3️⃣ Send to manual match API
    const response = await axios.post(
      `${BASE_URL}/account/match-saved-data-manually`,
      {
        bank_id: selectedBank2
      },
      { headers }
    );

    Swal.fire({
      icon: "success",
      title: "Success",
      text: response.data.message,
    });

    // 4️⃣ Reload transactions
    fetchTransaction(selectedBank2);

  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Failed",
      text: JSON.stringify(error?.response?.data?.message || "Failed to save. Try again."),
    });
  } finally {
    setLoading(false);
  }
};


const handleSave2 = async () => {
  setLoading(true);

  try {
    // Always read from localStorage — React state may be stale if called immediately after handleUnMatch
    const stored = JSON.parse(localStorage.getItem("pendingUnmatchedIds") || "[]");
    const combinedIds = Array.isArray(stored) ? stored : [];

    if (combinedIds.length === 0) {
      Swal.fire({ icon: 'warning', title: 'No Saved Data', text: 'There is no unmatched data saved.' });
      return;
    }

    const response = await axios.post(
      `${BASE_URL}/account/manual-unmatch`,
      { match_id: combinedIds },
      { headers }
    );

    // Cleanup
    localStorage.removeItem("pendingUnmatchedIds");
    setMatchedAmount(0);
    setUnmatch(false);
    setPendingUnmatchedIds([]);

    Swal.fire({ icon: 'success', title: 'Success', text: response.data.message });

    // Reload — use whichever view was active
    if (selectedMatch === 1) {
      fetchAllMatchedDate();
    } else {
      fetchTransaction();
    }
  } catch (error) {
    const msg = error.response?.data?.message
      ? JSON.stringify(error.response.data.message)
      : 'An error occurred. Please try again.';
    Swal.fire({ icon: 'error', title: 'Failed', text: msg });
  } finally {
    setLoading(false);
  }
};


  const handleSaveAction = async () => {
    if (unmatch) {
      await handleSave2(); // Call handleSave2 when unmatch is true
    } else {
      await handleSave(); // Call handleSave when unmatch is false
    }
  };

  const normalizeAmount = (value) => {
  const num = parseFloat(value);
  return Object.is(num, -0) ? 0 : num;
};

const formatCurrency = (value) => {
  const num = Number(value);

  // remove negative zero only
  const safeValue = Object.is(num, -0) || num === 0 ? 0 : num;

  return safeValue.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const handleCheckboxChange = (item) => {
  const id = item.id;

  if (selectedItems.includes(id)) {
    setSelectedItems(selectedItems.filter(x => x !== id));

    const amount =
  item.crdr === "1" ? -toKobo(item.amount) : toKobo(item.amount);

    
setMatchedAmount(prev => normalizeAmount(prev - amount));
  } else {
    setSelectedItems([...selectedItems, id]);

    const amount =
  item.crdr === "1" ? -toKobo(item.amount) : toKobo(item.amount);

    setMatchedAmount(prev => normalizeAmount(prev + amount));
  }
};

console.log('matchedamount:', matchedAmount);



const handleCheckboxChanges = (item) => {
  const id = item.id;

  if (selectedItemss.includes(id)) {
    setSelectedItemss(selectedItemss.filter(x => x !== id));

    const amount =
  item.crdr === "2" ? toKobo(item.amount) : -toKobo(item.amount);

    setMatchedAmount(prev => normalizeAmount(prev - amount));
  } else {
    setSelectedItemss([...selectedItemss, id]);

    const amount =
  item.crdr === "2" ? toKobo(item.amount) : -toKobo(item.amount);

    setMatchedAmount(prev => normalizeAmount(prev + amount));
  }
};




  // Handle "Select All" checkbox change
const handleSelectAll = () => {
  if (!selectAll) {
    const ids = currentPageData.map(item => item.id);

    const pageTotal = currentPageData.reduce((sum, item) => {
      const amount =
        item.crdr === "1" ? -item.amount : item.amount;

      return sum + parseFloat(amount);
    }, 0);

    setSelectedItems([...new Set([...selectedItems, ...ids])]);
    setMatchedAmount(prev => normalizeAmount(prev + pageTotal));
  } else {
    const ids = currentPageData.map(item => item.id);

    setSelectedItems(prev => prev.filter(id => !ids.includes(id)));

    const pageTotal = currentPageData.reduce((sum, item) => {
      const amount =
        item.crdr === "1" ? -item.amount : item.amount;

      return sum + parseFloat(amount);
    }, 0);

    setMatchedAmount(prev => normalizeAmount(prev - pageTotal));
  }

  setSelectAll(!selectAll);
};



  const handleSelectAlls = () => {
    setSelectAlls(!selectAlls);

    if (!selectAlls) {
      // If "Select All" is checked, select all items on the current page
      const updatedSelectedItemss = currentPageDatas.map(item => item.id);
      setSelectedItemss(updatedSelectedItemss);

      // Calculate the total matchedAmount for all selected items
      const totalAmount = currentPageDatas.reduce((total, item) => {
        const amount = item.crdr === "2"
          ? item.amount
          : item.crdr === "1"
            ? -item.amount
            : item.amount;

        return total + parseFloat(amount);
      }, 0);

      setMatchedAmount(normalizeAmount(totalAmount));
    } else {
      setSelectedItemss([]);
      setMatchedAmount(0);
    }
  };



  useEffect(() => {
    const sum = tableData.reduce((acc, item) => acc + parseFloat(item.crdr === "1" ? item.amount : item.crdr === "2" ? -item.amount : item.amount), 0);
    setTotalCashbookBalance(sum);
  }, [tableData]);

  useEffect(() => {
    const balance = tableDatas.reduce((sum, item) => {
      const value = parseFloat(
        item.crdr === "2" ? item.amount : item.crdr === "1" ? -item.amount : item.amount
        // item.debit === "0.00" ? item.credit : (item.credit === "0.00" ? -item.debit : item.debit)
      );
      return sum + value;
    }, 0);
    setTotalStatementBalance(balance);
  }, [tableDatas]);

  const displayMatched = fromKobo(matchedAmount);

 const handleMatch = async () => {
  if (matchedAmount !== 0) return;

  if (selectedItems.length === 0 && selectedItemss.length === 0) {
    Swal.fire({
      icon: 'error',
      title: 'Failed',
      text: 'Select a row to start matching',
    });
    return;
  }

  // Loader
  Swal.fire({
    title: 'Matching your items',
    text: 'Please wait...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => Swal.showLoading(),
  });

  try {
    const selectedCashbooks = tableData.filter(item =>
      selectedItems.includes(item.id)
    );

    const selectedStatements = tableDatas.filter(item =>
      selectedItemss.includes(item.id)
    );

    const payload = {
      cashbook_id: selectedCashbooks.map(item => item.id),
      cashbooks_amount: selectedCashbooks.map(item => item.amount),
      statement_id: selectedStatements.map(item => item.id),
      statements_amount: selectedStatements.map(item => item.amount),
    };

    await axios.post(
      `${BASE_URL}/account/save-for-manual-match`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${bearer}`,
        },
      }
    );

    Swal.close();

    fetchTransaction();

    setSelectedItems([]);
    setSelectedItemss([]);
    setMatchedAmount(0);

    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: 'Match saved successfully.',
    });
  } catch (error) {
    Swal.close();

    Swal.fire({
      icon: 'error',
      title: 'Error',
      text:
        error?.response?.data?.message ||
        'Failed to save match.',
    });
  }
};






const handleUnMatch = async () => {
  if (selectedItems.length === 0 && selectedItemss.length === 0) {
    Swal.fire({ icon: 'error', title: 'Failed', text: 'Select a row to start unmatching' });
    return;
  }

  try {
    const selectedCashbooks = tableData.filter(item => selectedItems.includes(item.id));
    const selectedStatements = tableDatas.filter(item => selectedItemss.includes(item.id));

    const newPendingIds = [
      ...selectedCashbooks.map(item => item.match_id),
      ...selectedStatements.map(item => item.match_id),
    ].filter(Boolean);

    // Always merge into localStorage — works for both matched and unmatched views
    const stored = JSON.parse(localStorage.getItem("pendingUnmatchedIds") || "[]");
    const merged = [...new Set([...stored, ...newPendingIds])];
    localStorage.setItem("pendingUnmatchedIds", JSON.stringify(merged));
    setPendingUnmatchedIds(merged); // keep state in sync for display

    setSelectedItems([]);
    setSelectedItemss([]);
    setMatchedAmount(0);
    setUnmatch(true);

    if (selectedMatch === 1) {
      await fetchAllMatchedDate();
    }

    Swal.fire({ icon: 'success', title: 'Saved', text: 'Items added to unmatch list.' });
  } catch (error) {
    Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to save unmatched items.' });
  }
};


  const [period, setPeriod] = useState([]);
  const [document, setDocument] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState('');
  const [selectBank, setSelectBank] = useState('');
  const [periodLoading, setPeriodLoading] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);

  const handlePeriodChange = (selectedOption) => {
    setSelectedPeriod(selectedOption.value);
  };
  const handleBankk = (selectedOption) => {
    setSelectBank(selectedOption.value);
  };


  const fetchPeriod = async () => {
    setPeriodLoading(true);

    try {
      const response = await axios.get(
        `${BASE_URL}/provinces/get-province-months-for-bank-statement`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );
      const results = response.data?.data;
      setPeriod(results);

      //   console.log(results, "NIYIN");
    } catch (error) {
      const errorStatus = error.response.data.message;
      console.error(errorStatus);
    } finally {
      setPeriodLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchPeriod();
    }
  }, [bearer]);

  const opt12 = period.map((item) => ({
    label: item.description,
    value: item.description,
  }));

  const handlePrint = async () => {
    setCreateLoading(true);
    try {

      const response = await axios.post(
        `${BASE_URL}/account/reconciliation-summary`,
        {
          gl_code: selectBank,
          date: selectedPeriod,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );
      const result = response.data.data;
      setDocument(result);
      // Swal.fire({
      //   icon: 'success',
      //   title: 'Successful',
      //   text: response.data.message,
      // });
      handleClose();
      navigate('/accounting/reconciliation_report', { state: { document: result } });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        console.log(error);
      }
    } finally {
      setCreateLoading(false);
    }
  };


  return (
    <div>
      {
        openNav && (
          <MobileMenu setOpenNav={setOpenNav} openNav={openNav} />)
      }

      {/* <LatestDash setOpenNav={setOpenNav} openNav={openNav} /> */}

      <div className={classes.finishedbodyCont}>



        <div className={classes.mainasdflkj}>
          <div className={classes.leftasdflkj}>
            <div className={classes.iconsStyle}>
              <IoMdCheckmark
                onClick={() => handleMatch()}
                style={{
                  color: disabled || matchedDisplayed ? 'gray' : 'green',
                  cursor: disabled || matchedDisplayed ? 'not-allowed' : 'pointer',
                  opacity: disabled || matchedDisplayed ? 0.5 : 1,
                  pointerEvents: disabled || matchedDisplayed ? 'none' : 'auto',
                }}
                size={25}
              />
              <ImCancelCircle
              onClick={() => handleUnMatch()}
               style={{ 
               color: !matchedDisplayed ? 'gray' : 'red', 
               cursor: !matchedDisplayed ? 'not-allowed' : 'pointer',
               opacity: !matchedDisplayed ? 0.5 : 1,
               pointerEvents: !matchedDisplayed ? 'none' : 'auto',
                }} size={25} />
              <FaRegSave onClick={() => handleSaveAction()} size={25} style={{ cursor: "pointer" }} />
              <GrPowerCycle style={{ color: 'orange', cursor: "pointer" }} size={25} />
              <FaPrint onClick={handleShow} style={{ color: 'green', cursor: "pointer" }} size={25} />
            </div>
           
          </div>
          
          <div className={classes.iconsStyle}>
            <p style={{ fontWeight: 700, color: "black", marginTop: 10 }}>
             ₦{displayMatched.toLocaleString('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})}
            </p>
          </div>
         
          
          
           <div className={classes.leftasdflkj1} >
            <div className="form-group row" style={{}}>
             
              <div >
                <div style={{ width: 250 }}>
                  <Select
                    options={[
                      { value: '', label: 'Select a category' },
                      { value: 1, label: 'All Matched Items' },
                      { value: 2, label: 'Automatch' },
                      { value: 3, label: 'Man-Match Items' },
                      { value: 4, label: 'Reversal' }
                    ]}
                    placeholder="Select Category"
                    onChange={handleMatchChange}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: '300px',
                        overflowY: 'auto',
                      }),
                    }}
                  />

                </div>
                
              </div>
            </div>
          </div>
        </div>
        <Modal show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Print Reconciliation Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form style={{ marginTop: 20 }}>
              <Form.Label className={classes.formLabelCustom}>Bank:</Form.Label>
              <Select

                options={selectOptions1}
                placeholder='Select Bank'
                onChange={handleBankk}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: '300px',
                    // maxWidth: '400px',
                    overflowY: 'auto',
                  }),
                }}
              />
              <Form.Label className={classes.formLabelCustom}>Date:</Form.Label>
              <Select
                className={classes.formControl}
                options={opt12}
                placeholder="Select Date"
                onChange={handlePeriodChange}
                menuPortalTarget={document.body}
                styles={{
                  width: "100%",
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: '100px',
                    overflowY: 'auto',

                  }),
                }}
              />
            </Form>
          </Modal.Body>






          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>
              Go back
            </Button>
            <Button variant="success" onClick={handlePrint}>
              {createLoading ? (
                <>
                  <Spinner size='sm' />
                  <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                </>
              ) : (
                "Print Report"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        <div className={classes.mainform}>

          <div className={classes.loandgrantcards}>
            <div className={classes.tab1}>

              {load && (
                <div className="d-flex justify-content-center align-items-center" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  zIndex: 1000,
                }}>
                  <Spinner animation="border" variant="primary" />
                </div>
              )}

              {loading && (
                <div className="d-flex justify-content-center align-items-center" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  zIndex: 1000,
                }}>
                  <Spinner animation="border" variant="primary" />
                </div>
              )}

              <div className={classes.leftRecon} >
                <div className={classes.ledgerTop}>
                  <div className={classes.ledgerTop1}>
                    <h4 className={classes.ledgerText}>Ledger (Balance : ₦{parseFloat(totalCashbookBalance).toLocaleString('en-US', {
                      minimumIntegerDigits: 1,
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })})</h4>
                    {/* <p className={classes.ledgerMatched}>111 of 111 matched</p> */}
                  </div>
                  <div className={`d-flex justify-content-between align-items-center ${classes.btnStyle}`} >
                    <div className="text-right modal-effect ">
                      <div id="DataTables_Table_0_filter" className="dataTables_filter">
                        <div className="d-flex justify-content-start align-items-center">
                          <div className="mr-2">Search:</div>
                          <input
                            type="search"
                            value={searchTerm}
                            className="form-control form-control-sm"
                            placeholder="Search by details or amount"
                            aria-controls="DataTables_Table_0"
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className={classes.mainTable}>

                  <div className="table-responsive">
                    <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">

                      <thead style={{ whiteSpace: 'nowrap' }}>
                        <tr>
                          <th style={{ width: 0, padding: 0 }}>
                            <input
                              type="checkbox"
                              checked={selectAll}
                              onChange={handleSelectAll}
                            />
                          </th>
                          <th style={{ width: 0, padding: 0 }}></th>
                          <th style={{ width: 0, padding: 0 }}>Post Date</th>
                          <th style={{ width: 0, padding: 0 }}>Val Date</th>
                          <th style={{ width: 0, padding: 0 }}>Details</th>
                          <th style={{ width: 0, padding: 0 }}>Amount</th>
                        </tr>
                      </thead>
                      <tbody style={{ whiteSpace: 'nowrap' }}>
                        {currentPageData.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center">No data to be displayed</td>
                          </tr>
                        ) : (
                          currentPageData.map((item, index) => (
                            <tr key={index}>
                              <td style={{ width: 0, padding: 0 }}><input type='checkbox' className={classes.inPutTextBox} checked={selectedItems.includes(item.id)}

                                onChange={() => handleCheckboxChange(item)} /></td>
                              <td style={{ width: 0, padding: 0 }}><IoChatbubblesSharp /> <FaUpload style={{ fontSize: '10px', }} /><FaDownload style={{ fontSize: '10px' }} /></td>
                              <td style={{ fontSize: 12, width: 0, padding: 0, color: matchedDisplayed === true ? "green" : "black" }}>{formatDate(item.post_date)}</td>
                              <td style={{ fontSize: 12, width: 0, padding: 0, color: matchedDisplayed === true ? "green" : "black" }}>{formatDate(item.val_date)}</td>
                              <td style={{ width: 300, fontSize: 12, whiteSpace: "wrap", color: matchedDisplayed === true ? "green" : "black" }}>{item.description}</td>
                              <td style={{ fontSize: 12, textAlign: "right", width: 20, color: matchedDisplayed === true ? "green" : "black" }}>
                                {parseFloat(
                                  item.crdr === "2"
                                    ? item.amount
                                    : item.crdr === "1"
                                      ? -item.amount
                                      : item.amount
                                ).toLocaleString('en-US', {
                                  minimumIntegerDigits: 1,
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {currentPageData.length > 0 && (
                  <div className="d-flex justify-content-center align-items-center mt-3">
                    {/* Previous Button */}
                    <button
                      style={{
                        border: 'none',
                        backgroundColor: 'gainsboro',
                        borderRadius: 3,
                        height: '2.5rem',
                        width: '100px',
                        fontWeight: 500,
                        fontSize: 14,
                        padding: '0.5rem',
                        fontFamily: 'Nunito',
                        color: '#000',
                        marginRight: 10,
                        cursor: 'pointer',
                      }}
                      onClick={() => setCurrentPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>

                    {/* Page Number Buttons */}
                    {(() => {
                      const maxVisiblePages = 5; // Maximum number of visible pages
                      let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
                      let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

                      if (endPage - startPage < maxVisiblePages - 1) {
                        startPage = Math.max(1, endPage - maxVisiblePages + 1);
                      }

                      const pages = [];
                      for (let i = startPage; i <= endPage; i++) {
                        pages.push(
                          <button
                            key={i}
                            className={`btn btn-secondary rounded mx-1 ${currentPage === i ? 'active' : ''
                              }`}
                            style={{
                              width: '30px',
                              height: '30px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              padding: '0',
                              fontWeight: currentPage === i ? 'bold' : 'normal',
                              fontSize: 12,
                            }}
                            onClick={() => setCurrentPage(i)}
                          >
                            {i}
                          </button>
                        );
                      }

                      return pages;
                    })()}

                    {/* Last Page Button */}
                    {totalPages > 5 && currentPage < totalPages - 2 && (
                      <>
                        <span style={{ padding: '0 5px', fontSize: 12 }}>...</span>
                        <button
                          className={`btn btn-primary rounded mx-1 ${currentPage === totalPages ? 'active' : ''
                            }`}
                          style={{
                            width: '30px',
                            height: '30px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '0',
                            fontWeight: currentPage === totalPages ? 'bold' : 'normal',
                            fontSize: 12,
                          }}
                          onClick={() => setCurrentPage(totalPages)}
                        >
                          {totalPages}
                        </button>
                      </>
                    )}

                    {/* Next Button */}
                    <button
                      style={{
                        border: 'none',
                        backgroundColor: 'gainsboro',
                        borderRadius: 3,
                        height: '2.5rem',
                        width: '100px',
                        fontWeight: 500,
                        fontSize: 14,
                        padding: '0.5rem',
                        fontFamily: 'Nunito',
                        color: '#000',
                        marginLeft: 10,
                        cursor: 'pointer',
                      }}
                      onClick={() => setCurrentPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>

                )}



              </div>

              <div className={classes.rightRecon} >
                <div className={classes.ledgerTop}>
                  <div className={classes.ledgerTop1}>
                    <h4 className={classes.ledgerText}>Statement (Balance : ₦{parseFloat(totalStatementBalance).toLocaleString('en-US', {
                      minimumIntegerDigits: 1,
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })})</h4>
                    {/* <p className={classes.ledgerMatched}>111 of 111 matched</p> */}
                  </div>
                  <div className={`d-flex justify-content-between align-items-center ${classes.btnStyle}`}>
                    <div className="text-right modal-effect ">
                      <div id="DataTables_Table_0_filter" className="dataTables_filter">
                        <div className="d-flex justify-content-start align-items-center">
                          <div className="mr-2">Search:</div>
                          <input

                            type="search"
                            value={searchTerms}
                            className="form-control form-control-sm"
                            placeholder="Search by details or amount"
                            aria-controls="DataTables_Table_0"
                            onChange={(e) => setSearchTerms(e.target.value)}
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className={classes.mainTable}>
                  <div className="table-responsive">
                    <table className="table display table-bordered table-striped table-hover bg-white m-0 card-table">
                      <thead style={{ whiteSpace: 'nowrap' }}>
                        <tr>
                          <th style={{ width: 0, padding: 0 }}>
                            <input
                              type="checkbox"
                              checked={selectAlls}
                              onChange={handleSelectAlls}
                            />
                          </th>
                          <th style={{ width: 0, padding: 0 }}></th>
                          <th style={{ width: 0, padding: 0 }}>Post Date</th>
                          <th style={{ width: 0, padding: 0 }}>Val Date</th>
                          <th style={{ width: 0, padding: 0 }}>Details</th>
                          <th style={{ width: 0, padding: 0 }}>Amount</th>
                        </tr>
                      </thead>
                      <tbody style={{ whiteSpace: 'nowrap' }}>
                        {currentPageDatas.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center">No data to be displayed</td>
                          </tr>
                        ) : (
                          currentPageDatas.map((item, index) => (

                            <tr key={index}>
                              <td style={{ width: 0, padding: 0 }}>

                                <input
                                  type="checkbox"
                                  className={classes.inPutTextBox}
                                  checked={selectedItemss.includes(item.id)}
                                  onChange={() => handleCheckboxChanges(item)}
                                />
                              </td>
                              <td style={{ width: 0, padding: 0 }}><IoChatbubblesSharp /> <FaUpload style={{ fontSize: '10px' }} /><FaDownload style={{ fontSize: '10px' }} /></td>
                              <td style={{ fontSize: 12, width: 0, padding: 0, color: matchedDisplayed === true ? "green" : "black" }}>{formatDate(item.post_date)}</td>
                              <td style={{ fontSize: 12, width: 0, padding: 0, color: matchedDisplayed === true ? "green" : "black" }}>{formatDate(item.val_date)}</td>
                              <td style={{ width: 300, fontSize: 12, whiteSpace: "wrap", color: matchedDisplayed === true ? "green" : "black" }}>{item.description}</td>
                              <td style={{ fontSize: 12, textAlign: "right", width: 20, color: matchedDisplayed === true ? "green" : "black" }}>
                                {parseFloat(
                                  item.crdr === "2"
                                    ? item.amount
                                    : item.crdr === "1"
                                      ? -item.amount
                                      : item.amount
                                ).toLocaleString('en-US', {
                                  minimumIntegerDigits: 1,
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}
                              </td>

                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {currentPageDatas.length > 0 && (
                  <div className="d-flex justify-content-center align-items-center mt-3">
                    {/* Previous Button */}
                    <button
                      style={{
                        border: 'none',
                        backgroundColor: 'gainsboro',
                        borderRadius: 3,
                        height: '2.5rem',
                        width: '100px',
                        fontWeight: 500,
                        fontSize: 14,
                        padding: '0.5rem',
                        fontFamily: 'Nunito',
                        color: '#000',
                        marginRight: 10,
                        cursor: 'pointer',
                      }}
                      onClick={() => setCurrentPages(currentPages - 1)}
                      disabled={currentPages === 1}
                    >
                      Previous
                    </button>

                    {/* Page Number Buttons */}
                    {(() => {
                      const maxVisiblePages = 5; // Maximum number of visible pages
                      let startPage = Math.max(1, currentPages - Math.floor(maxVisiblePages / 2));
                      let endPage = Math.min(totalPages1, startPage + maxVisiblePages - 1);

                      if (endPage - startPage < maxVisiblePages - 1) {
                        startPage = Math.max(1, endPage - maxVisiblePages + 1);
                      }

                      const pages = [];
                      for (let i = startPage; i <= endPage; i++) {
                        pages.push(
                          <button
                            key={i}
                            className={`btn btn-secondary rounded mx-1 ${currentPages === i ? 'active' : ''
                              }`}
                            style={{
                              width: '30px',
                              height: '30px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              padding: '0',
                              fontWeight: currentPages === i ? 'bold' : 'normal',
                              fontSize: 12,
                            }}
                            onClick={() => setCurrentPages(i)}
                          >
                            {i}
                          </button>
                        );
                      }

                      return pages;
                    })()}

                    {/* Last Page Button */}
                    {totalPages1 > 5 && currentPages < totalPages1 - 2 && (
                      <>
                        <span style={{ padding: '0 5px', fontSize: 12 }}>...</span>
                        <button
                          className={`btn btn-primary rounded mx-1 ${currentPages === totalPages1 ? 'active' : ''
                            }`}
                          style={{
                            width: '30px',
                            height: '30px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '0',
                            fontWeight: currentPages === totalPages1 ? 'bold' : 'normal',
                            fontSize: 12,
                          }}
                          onClick={() => setCurrentPages(totalPages1)}
                        >
                          {totalPages1}
                        </button>
                      </>
                    )}

                    {/* Next Button */}
                    <button
                      style={{
                        border: 'none',
                        backgroundColor: 'gainsboro',
                        borderRadius: 3,
                        height: '2.5rem',
                        width: '100px',
                        fontWeight: 500,
                        fontSize: 14,
                        padding: '0.5rem',
                        fontFamily: 'Nunito',
                        color: '#000',
                        marginLeft: 10,
                        cursor: 'pointer',
                      }}
                      onClick={() => setCurrentPages(currentPages + 1)}
                      disabled={currentPages === totalPages1}
                    >
                      Next
                    </button>
                  </div>

                )}
              </div>

            </div>
          </div>
        </div>

      </div>






    </div >
  )
}